module.exports = __webpack_public_path__ + "static/media/85450037-3PB0wSgs.fd531b22.JPG";